import OnPremiseModal from './OnPremiseModal';

export default OnPremiseModal;
